/* NavKar builders: shared helpers. Live prices from /products/<handle>.js, add to cart, WhatsApp. */
(function(){
if(window.NKB)return;
var cache={};
function one(h){
  if(!cache[h])cache[h]=fetch('/products/'+h+'.js',{credentials:'same-origin'}).then(function(r){return r.ok?r.json():null}).catch(function(){return null});
  return cache[h];
}
function pick(p){
  if(!p)return null;
  var v=p.variants.filter(function(x){return x.available})[0]||p.variants[0];
  var img=p.featured_image||'';
  if(img&&img.indexOf('//')===0)img='https:'+img;
  return {title:p.title,price:v.price,cmp:(v.compare_at_price&&v.compare_at_price>v.price)?v.compare_at_price:0,vid:v.id,avail:!!v.available,img:img,url:'/products/'+p.handle};
}
function load(map){
  var keys=Object.keys(map),out={};
  return Promise.all(keys.map(function(k){
    var hs=[].concat(map[k]);
    return Promise.all(hs.map(one)).then(function(ps){
      var got=ps.map(pick).filter(Boolean);
      out[k]=got.filter(function(x){return x.avail})[0]||got[0]||null;
    });
  })).then(function(){return out});
}
function money(p){
  return '₹'+Math.round((p||0)/100).toLocaleString('en-IN');
}
function img(u,w){
  if(!u)return '';
  return u+(u.indexOf('?')>-1?'&':'?')+'width='+(w||120);
}
function post(url,body){
  return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})});
}
function add(items,note){
  items=items.filter(function(i){return i&&i.id&&i.quantity>0});
  var failed=[];
  return post('/cart/add.js',{items:items}).catch(function(){
    return items.reduce(function(pr,it){
      return pr.then(function(){return post('/cart/add.js',{items:[it]}).catch(function(e){failed.push({it:it,msg:(e&&(e.description||e.message))||''})})});
    },Promise.resolve());
  }).then(function(){
    if(note)return post('/cart/update.js',{attributes:note}).catch(function(){});
  }).then(function(){return failed});
}
function wa(t){return 'https://wa.me/919138468548?text='+encodeURIComponent(t)}
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
function stepper(val,min,max,on){
  var w=document.createElement('div');w.className='nkb-q';
  w.innerHTML='<button type="button" aria-label="Fewer">−</button><output aria-live="polite"></output><button type="button" aria-label="More">+</button>';
  var b=w.querySelectorAll('button'),o=w.querySelector('output');
  function set(v){val=Math.max(min,Math.min(max,v));o.textContent=val;b[0].disabled=val<=min;b[1].disabled=val>=max;on(val)}
  b[0].onclick=function(){set(val-1)};b[1].onclick=function(){set(val+1)};
  w.set=function(v){set(v)};set(val);return w;
}
window.NKB={load:load,money:money,img:img,add:add,wa:wa,esc:esc,stepper:stepper,giftOn:Date.now()<1794767399000};
})();
